import { get_richieste_pendenti_count } from '@/api/api.abbonamento.js'

const app = {
    namespaced: true,

    state: {
        loading: false,

        snackbar: {
            visibile: false,
            testo: '',
            tipo: 'error'  // 'error' | 'success' | 'warning'
        },

        richiestePendenti: 0
    },

    actions: {

        async aggiornaRichiestePendenti({ commit }) {
            try {
                const res = await get_richieste_pendenti_count()
                commit('SET_RICHIESTE_PENDENTI', res.data)
            } catch { /* ignora */ }
        },
    },

    mutations: {
        SET_RICHIESTE_PENDENTI(state, count) {
            state.richiestePendenti = count
        },
        SET_LOADING(state, vis) {
            state.loading = vis
        },

        showMessage(state, { testo, tipo = 'error' }) {
            state.snackbar.testo = testo
            state.snackbar.tipo = tipo
            state.snackbar.visibile = true
        },
        hideMessage(state) {
            state.snackbar.visibile = false
        }

    },

    getters: {
        getRichiestePendenti: state => state.richiestePendenti
    }
}

export default app